import BasePageStore, {PageState} from "../BasePageStore";
import {Log} from "../../helpers/log";
import {makeObservable, observable, runInAction} from "mobx";
import {ApiApplicationIdRenderedGet} from "../../services/api/applications/ApiApplicationIdRenderedGet";
import {applicationsStore} from "../singletones/ApplicationsStore";

class RobokassaResultPageStore extends BasePageStore {
  log = new Log("RobokassaResultPageStore");
  state: PageState | "submitted" | "no_application" = "init";
  error: unknown;

  applicationId = "";
  isSubmitted = false;

  private pollingInterval: number | null = null;
  private readonly POLL_INTERVAL_MS = 3000;

  constructor() {
    super();
    makeObservable(this, {
      state: observable,
      error: observable,
      applicationId: observable,
      isSubmitted: observable,
    });
  }

  async load(): Promise<void> {
    this.log.log("loading RobokassaResultPageStore");

    try {
      const currentApplication = await applicationsStore.getCurrentApplication();

      if (!currentApplication?.id) {
        this.log.error("No application found");
        runInAction(() => {
          this.state = "no_application";
        });
        return;
      }

      runInAction(() => {
        this.applicationId = currentApplication.id;
        this.state = "ok";
      });

      this.startPolling();
    } catch (e) {
      this.log.error("Error loading store", e);
      runInAction(() => {
        this.state = "error";
        this.error = e;
      });
    }
  }

  private startPolling(): void {
    this.log.log("Starting polling for application status");

    this.checkApplicationStatus();

    this.pollingInterval = window.setInterval(() => {
      this.checkApplicationStatus();
    }, this.POLL_INTERVAL_MS);
  }

  private async checkApplicationStatus(): Promise<void> {
    if (!this.applicationId) return;

    try {
      const response = await ApiApplicationIdRenderedGet(this.applicationId);
      const {show_submit_button} = response.data;

      if (show_submit_button === false) {
        this.log.log("Application is now submitted!");
        runInAction(() => {
          this.isSubmitted = true;
          this.state = "submitted";
        });
        this.stopPolling();

        setTimeout(() => {
          window.location.href = "/";
        }, 500);
      }
    } catch (e) {
      this.log.error("Error checking application status", e);
    }
  }

  stopPolling(): void {
    if (this.pollingInterval !== null) {
      this.log.log("Stopping polling");
      window.clearInterval(this.pollingInterval);
      this.pollingInterval = null;
    }
  }

  dispose(): void {
    this.stopPolling();
  }
}

export default RobokassaResultPageStore;
